import { authInstance } from './axios';
let url = process.env.REACT_APP_API_URL;

const triggerBlobDownload = (blob, filename) => {
  const downloadUrl = window.URL.createObjectURL(new Blob([blob]));
  const link = document.createElement('a');
  link.href = downloadUrl;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(downloadUrl);
};

const parseBlobErrorMessage = async (data) => {
  if (!data) return '';
  if (typeof data === 'string') {
    try {
      return JSON.parse(data)?.message || data;
    } catch (error) {
      return data;
    }
  }
  if (typeof data?.text === 'function') {
    try {
      const text = await data.text();
      return JSON.parse(text)?.message || text;
    } catch (error) {
      return '';
    }
  }
  return data?.message || '';
};

const getPdfFilename = (headers, fallback) => {
  const disposition =
    headers?.['content-disposition'] || headers?.['Content-Disposition'] || '';
  const match = String(disposition).match(/filename\*?=(?:UTF-8''|"?)([^";]+)/i);
  if (!match?.[1]) return fallback;
  try {
    return decodeURIComponent(match[1].replace(/"/g, '').trim());
  } catch (error) {
    return match[1].replace(/"/g, '').trim();
  }
};

export const membershipCatalogService = {
  getAvailableMemberships: async (params) => {
    for (const key in params) {
      if (params[key] === undefined || params[key] === '') {
        delete params[key];
      }
    }

    const response = await authInstance
      .get(`${url}/membershipCatalog?` + new URLSearchParams(params))
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  getPrices: async () => {
    const response = await authInstance
      .get(`${url}/membershipCatalog/prices`)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  getPricesForRetail: async () => {
    const response = await authInstance
      .get(`${url}/membershipCatalog/pricesForRetail`)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  getUpgradeMembership: async (membershipId) => {
    const response = await authInstance
      .get(`${url}/membershipCatalog/upgrades?membership=${membershipId}`)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  downloadMassivePricesPdf: async (body, filename) => {
    try {
      const response = await authInstance.post(
        `${url}/membershipCatalog/massivePricesPdf`,
        body,
        { responseType: 'blob' }
      );

      const contentType = String(
        response?.headers?.['content-type'] ||
          response?.headers?.['Content-Type'] ||
          response?.data?.type ||
          ''
      );
      const isJsonResponse = contentType.includes('application/json');

      if (response?.status === 200 && response?.data && !isJsonResponse) {
        triggerBlobDownload(
          response.data,
          getPdfFilename(response.headers, filename || 'cotizacion-planes.pdf')
        );
        return { status: 200 };
      }

      return {
        status: response?.status || 500,
        message:
          (await parseBlobErrorMessage(response?.data)) ||
          response?.message ||
          'Error al descargar el PDF',
      };
    } catch (error) {
      console.log('error', error);
      return {
        status: 500,
        message:
          (await parseBlobErrorMessage(error?.data)) ||
          error?.message ||
          'Error al descargar el PDF',
      };
    }
  },
};
